import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../axios/defaultAxios";
import { errorMessage, successMessage } from "../actions/messages.actions";

const ENDPOINT = "/file/v2";

/****** Get assets ******/

export const requestAssets = createAsyncThunk(
  `${slices.assets}/requestAssets`,
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}?${new URLSearchParams(params).toString()}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestAssetsStatus = {
  [requestAssets.fulfilled]: (state, action) => {
    state.loading = false;
    state.assets = action.payload.data;
    state.recordsCount = action.payload.records_count;
  },
  [requestAssets.pending]: (state, action) => {
    state.loading = true;
  },
  [requestAssets.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Delete single asset ******/

export const requestDeleteSingleAsset = createAsyncThunk(
  `${slices.assets}/requestDeleteSingleAsset`,
  async (assetId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${ENDPOINT}/${assetId}`);
      dispatch(successMessage(response.data.message));
      return { assetId, message: response.data.message };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestDeleteSingleAssetStatus = {
  [requestDeleteSingleAsset.fulfilled]: (state, action) => {
    state.assets = state.assets.filter((asset) => asset._id !== action.payload.assetId);
    state.loading = false;
  },
  [requestDeleteSingleAsset.pending]: (state, action) => {
    state.loading = true;
  },
  [requestDeleteSingleAsset.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Get single asset ******/

export const requestSingleAsset = createAsyncThunk(
  `${slices.assets}/requestSingleAsset`,
  async (assetId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}/${assetId}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestSingleAssetStatus = {
  [requestSingleAsset.fulfilled]: (state, action) => {
    state.loading = false;
    state.asset = action.payload;
  },
  [requestSingleAsset.pending]: (state, action) => {
    state.loading = true;
  },
  [requestSingleAsset.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Upload asset ******/

export const requestUploadAsset = createAsyncThunk(
  `${slices.assets}/requestUploadAsset`,
  async ({ assetId, assetData }, { rejectWithValue, dispatch }) => {
    try {
      Object.keys(assetData).forEach((key) => assetData[key] == null && delete assetData[key]);
      const response = await axios.put(`${ENDPOINT}/${assetId}`, assetData);
      dispatch(successMessage(response.data.message));
      return { data: response.data.data, message: response.data.message };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestUploadAssetStatus = {
  [requestUploadAsset.fulfilled]: (state, action) => {
    state.loading = false;
    state.asset = action.payload.data;
  },
  [requestUploadAsset.pending]: (state, action) => {
    state.loading = true;
  },
  [requestUploadAsset.rejected]: (state, action) => {
    state.loading = false;
  },
};
